import { takeLatest, put, call } from 'redux-saga/effects';

import { listControlePragaDoenca } from '../service';
import {
  NEW_FILTER_NEXT_PAGE_CONTROLE_PRAGA_DOENCA,
  NEW_FILTER_NEXT_PAGE_CONTROLE_PRAGA_DOENCA_PENDING,
  NEW_FILTER_NEXT_PAGE_CONTROLE_PRAGA_DOENCA_SUCCESS,
  NEW_FILTER_NEXT_PAGE_CONTROLE_PRAGA_DOENCA_FAILURE,
} from '../actionTypes';
import { CONST_FILTER_CONTROLE_PRAGA_DOENCA } from '@commons/consts';

function* sagaNewFilterNextPageControlePragaDoenca(action) {
  yield put({ type: NEW_FILTER_NEXT_PAGE_CONTROLE_PRAGA_DOENCA_PENDING });

  try {
    let filterSaved = sessionStorage.getItem(CONST_FILTER_CONTROLE_PRAGA_DOENCA) !== null
      ? JSON.parse(sessionStorage.getItem(CONST_FILTER_CONTROLE_PRAGA_DOENCA))
      : null;

    if (filterSaved !== null && filterSaved !== undefined) {

      const newFilter = {
        ...filterSaved,
        page: action.page,
        rows: action.rows
      };

      // Buscar registros
      const queryString = `?size=${newFilter.rows}&page=${newFilter.page}${newFilter.where}`;
      const list = yield call(listControlePragaDoenca, queryString);

      sessionStorage.setItem(CONST_FILTER_CONTROLE_PRAGA_DOENCA, JSON.stringify(newFilter));

      yield put({
        type: NEW_FILTER_NEXT_PAGE_CONTROLE_PRAGA_DOENCA_SUCCESS,
        list: list,
        filter: newFilter
      });
    } else {
      yield put({ type: NEW_FILTER_NEXT_PAGE_CONTROLE_PRAGA_DOENCA_FAILURE });
    }
  } catch (error) {
    yield put({ type: NEW_FILTER_NEXT_PAGE_CONTROLE_PRAGA_DOENCA_FAILURE });
    // console.error(error) // eslint-disable-line
  }
}

export default function* watchNewFilterNextPageControlePragaDoenca() {
  yield takeLatest(NEW_FILTER_NEXT_PAGE_CONTROLE_PRAGA_DOENCA, sagaNewFilterNextPageControlePragaDoenca);
}
